
import { useCallback, useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate, useParams } from "react-router";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, Tab, Tabs, TextField, Typography } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";

import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";
import { TabPanel, TabProps } from "../../../helpers/TabPanel";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxInformacionAmparo } from "../../../components/BoxInformacionAmparo";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionIrregular } from "../../../components/BoxInformacionIrregular";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { DialogDocumento } from "../../../dialogs/DialogDocumento";
import { DialogAgregarDomicilio } from "../../../dialogs/DialogAgregarDomicilio";

import { ObtenerTipoNotificacion } from "../../../connections/catalogos/TipoNotificacionConnection";
import { ObtenerFormaNotificacion } from "../../../connections/catalogos/FormaNotificacionConnection";
import { ObtenerPlantilla, ObtenerPlantillaDetalle } from "../../../connections/admin/PlantillaConnection";
import { ActualizarEstatus, GuardarNotificacion, DetalleNotificacion } from "../../../connections/notificaciones/NotificacionConnection";

import { PlantillaProps } from "../../../interfaces/admin/PlantillaInterface";
import { DomicilioProps } from "../../../interfaces/comun/DomicilioInterface";
import { TipoNotificacionProps } from "../../../interfaces/catalogos/TipoNotificacionInterface";
import { FormaNotificacionProps } from "../../../interfaces/catalogos/FormaNotificacionInterface";
import { defaultNotificacion, NotificacionProps } from "../../../interfaces/notificaciones/NotificacionesInterface";

DocumentEditorContainerComponent.Inject(Toolbar);

interface ItemModelModif extends ItemModel {
    value?: string;
    tipoAcuerdo?: string;
    fecha?: string;
}

const defaultDocument = DefaultDocumentEditor();

export const GenerarNotificacionPage = () => {

    const { Id } = useParams();

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const dropCampos = useRef<DropDownButton>( null );
    const dropCamposAcuerdos = useRef<DropDownButton>( null );
    const notificacionRef = useRef<NotificacionProps>( defaultNotificacion );
    const insertarContenidoAcuerdoRef = useRef<( value: string ) => void>( () => {} );
    const initialPage = useRef( false );

    const [onChangeTab, setOnChangeTab] = useState( false );

    const [editorReady, setEditorReady] = useState( false );

    const [value, setValue] = useState( 0 );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );
    const [activarFinalizar, setActivarFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );
    const [openAgregarDomicilio, setOpenAgregarDomicilio] = useState( false );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );
    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [notificacion, setNotificacion] = useState<NotificacionProps>( defaultNotificacion );

    const [tipoNotificacion, setTipoNotificacion] = useState( 0 );
    const [tipoNotificacionArray, setTipoNotificacionArray] = useState<TipoNotificacionProps[]>( [] );

    const [formaNotificacion, setFormaNotificacion] = useState( 0 );
    const [formaNotificacionArray, setFormaNotificacionArray] = useState<FormaNotificacionProps[]>( [] );

    const [cancelarBoleta, setCancelarBoleta] = useState( false );
    const [motivoCancelacionBoleta, setMotivoCancelacionBoleta] = useState( '' );

    const [contenido, setContenido] = useState( '' );

    const [plantilla, setPlantilla] = useState( 0 );
    const [plantillaTemp, setPlantillaTemp] = useState( 0 );
    const [plantillaArray, setPlantillaArray] = useState<PlantillaProps[]>( [] );

    const [cancelarNotificacion, setCancelarNotificacion] = useState( false );

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => { setValue( newValue ); setOnChangeTab( true ); }

    const handleDomicilio = ( value: DomicilioProps ) => {

        const descripcionDomicilio = value.descripcion ?? "";
        const numeroDomicilio = value.numero?.toString() ?? "";
        const asentamiento = value.asentamiento?.descripcion ?? "";
        const codigoPostal = value.asentamiento?.codigoPostal ?? "";
        const municipio = value.asentamiento?.municipio?.descripcion ?? "";
        const estado = value.asentamiento?.estado?.descripcion ?? "";

        const domicilio = descripcionDomicilio + " #" + numeroDomicilio + ", Col. " + asentamiento + ", C.P " + codigoPostal + ", " + municipio + ", " + estado;

        setNotificacion( ( prev ) => ({ ...prev, domicilioNotificar: domicilio }) );

    }

    let Toolbar: ( CustomToolbarItemModel | ToolbarItem )[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
        },
    ];

    if ( ( notificacion.acuerdos ?? [] ).length !== 0 ) {

        Toolbar.push({
            tooltipText: 'Acuerdos',
            text: 'Acuerdos',
            id: 'dropItemAcuerdos',
        });
    }

    const validateFields = () => {

        let valid = true;

        if ( tipoNotificacion === 0 ) {
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un tipo de notificación', variant: 'warning' }));
        }

        if ( formaNotificacion === 0 ) {
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar una forma de notificación', variant: 'warning' }));
        }

        if ( ( !cancelarNotificacion && !cancelarBoleta ) && notificacion.domicilioNotificar === '' ) {
            valid = false;
            dispatch( openSnackbar({ message: 'Debes agregar un domicilio a notificar 1', variant: 'warning' }));
        }

        if ( cancelarBoleta && motivoCancelacionBoleta.trim() === '' ) {
            valid = false;
            dispatch( openSnackbar({ message: 'Debes agregar un motivo para la cancelación de la boleta', variant: 'warning' }));
        }

        return valid;

    }

    const Guardar = async () => {

        const params = {
            'id': Id ?? '',
            'contenido':  syncfusionEditor?.current?.documentEditor.serialize() ?? '',
            'idPlantilla': plantilla,
            'idTipoNotificacion': tipoNotificacion,
            'idFormaNotificacion': formaNotificacion,
            'turnarCentralActuarios': true,
            'cancelarBoleta': cancelarBoleta,
            'motivoCancelacionBoleta': motivoCancelacionBoleta,
            'cancelarNotificacion': cancelarNotificacion

        };

        return await GuardarNotificacion( params );
    }

    const handleGuardar = async () => {

        const validate = validateFields();

        if ( !validate ) {
            return false;
        }

        setLoadingGuardar(true);

        await Guardar().then(response => {

            setTimeout(() => {

                const { success, message } = response;

                if ( success ) {

                    dispatch( openSnackbar({ message: message, variant: 'success' }));
                    setActivarFinalizar(true);
                    setContenido( syncfusionEditor.current?.documentEditor.serialize() ?? "" );
                    setLoadingGuardar(false);

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingGuardar(false);

                }

            }, 700);

        });
    }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        const params = {
            'id': Id ?? '',
            'idEstatus': 29,
            'cancelarBoleta': cancelarBoleta,
            'motivoCancelacionBoleta': motivoCancelacionBoleta,
            'cancelarNotificacion': cancelarNotificacion,
            'turnarCentralActuarios': true,
        };

        await ActualizarEstatus(params).then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    if ( cancelarNotificacion || cancelarBoleta ) {

                        setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                        setProcesoTerminado( true );

                        setOpenDialogConfirmacionFinalizar(false);

                    }
                    else {

                        navigate(`/notificacion/visualizar/${ Id ?? '' }`);
                    }

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const obtenerPlantilla = async ( Id: number ) => {

        setPlantilla(Id);

        await ObtenerPlantillaDetalle(Id).then(response => {

            if ( response ) {

                if ( response.idPlantilla === Id ) {

                    const contenido = response?.contenido ?? "";

                    if ( !(/<\/?[a-z][\s\S]*>/.test(contenido)) ) {

                        const contentSetValues = reemplaceData( contenido );

                        syncfusionEditor.current?.documentEditor.open( insertarAcuerdoEnPosicion( contentSetValues ) );
                    }
                    else if ( /<\/?[a-z][\s\S]*>/.test( contenido ) ) {

                        const contenidoParser = contenido.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/&/g, "").replace(/acute;/g, "") ?? "";

                        const contentSetValues = reemplaceData( contenidoParser ).replaceAll('[Acuerdo_Notificar]', '');

                        syncfusionEditor.current?.documentEditor.open( defaultDocument );

                        syncfusionEditor.current?.documentEditor.editor.insertText( contentSetValues );
                    }
                    else {
                        syncfusionEditor.current?.documentEditor.open( defaultDocument );
                    }

                }
            }

        });

    }

    const reemplaceData = ( contenido: string ) => {

        const { expediente, amparo, exhortoRecibido, irregular } = notificacion;

        const contentSetValues = contenido
            .replaceAll('[Tipo_Notificacion]', notificacion.tipoNotificacion)
            .replaceAll('[Forma_Notificacion]', notificacion.formaNotificacion)
            .replaceAll('[Persona_Notificar]', notificacion.personaNotificar)
            .replaceAll('[Domicilio_Notificar]', notificacion.domicilioNotificar)
            .replaceAll('[Autoridad]', notificacion.autoridad)
            .replaceAll('[Ciudad]', notificacion.ciudad)            
            .replaceAll('[Numero_Boleta]', notificacion.numeroBoleta ?? '');

        if ( notificacion.idAmparo !== 0 ) {

            return contentSetValues
                .replaceAll('[Numero_Amparo]', amparo.numeroAmparo)
                .replaceAll('[Numero_Expediente]', expediente.numeroExpediente)
                .replaceAll('[Numero_Folio]', expediente.numeroFolio ?? '')
                .replaceAll('[Tipo_Juicio]', expediente.tipoJuicio ?? '')
                .replaceAll('[Actor]', expediente.actores.join(', '))
                .replaceAll('[Demandado]', expediente.demandados.join(', '))
                .replaceAll('[Juez]', amparo.juez);
        }

        if ( notificacion.idIrregular !== 0 ) {

            return contentSetValues
                .replaceAll('[Numero_Irregular]', irregular.numeroIrregular)
                .replaceAll('[Actor]', irregular.actores.join(', '))
                .replaceAll('[Demandado]', irregular.demandados.join(', '))
                .replaceAll('[Juez]', irregular.juez);
        }

        if ( notificacion.idExpediente !== 0 ) {

            return contentSetValues
                .replaceAll('[Numero_Expediente]', expediente.numeroExpediente)
                .replaceAll('[Numero_Folio]', expediente.numeroFolio ?? '')
                .replaceAll('[Tipo_Juicio]', expediente.tipoJuicio ?? '')
                .replaceAll('[Actor]', expediente.actores.join(', '))
                .replaceAll('[Demandado]', expediente.demandados.join(', '))
                .replaceAll('[Juez]', expediente.juez);
        }

        if ( notificacion.idExhortoRecibido !== 0 ) {

            return contentSetValues
                .replaceAll('[Numero_Exhorto]', exhortoRecibido.numeroExhorto)
                .replaceAll('[Numero_Folio]', exhortoRecibido.numeroFolio ?? '')
                .replaceAll('[Tipo_Juicio]', exhortoRecibido.tipoJuicio ?? '')
                .replaceAll('[Actor]', exhortoRecibido.actores.join(', '))
                .replaceAll('[Demandado]', exhortoRecibido.demandados.join(', '))
                .replaceAll('[Juez]', exhortoRecibido.juez);
        }

        return contentSetValues;
    }

    const buscarYSustituirAcuerdo = ( nodo: any, bloquesAcuerdo: any[] ): boolean => {

        if ( Array.isArray( nodo ) ) {

            for ( let i = 0; i < nodo.length; i++ ) {

                const bloque = nodo[i];
                const indiceRun = bloque?.i?.findIndex( ( run: any ) => run?.tlp === '[Acuerdo_Notificar]' ) ?? -1;

                if ( indiceRun !== -1 ) {

                    bloque.i.splice( indiceRun, 1 );

                    const parrafoVacio = bloque.i.length === 0;

                    nodo.splice( parrafoVacio ? i : i + 1, parrafoVacio ? 1 : 0, ...bloquesAcuerdo );

                    return true;
                }

                if ( buscarYSustituirAcuerdo( bloque, bloquesAcuerdo ) ) { return true; }
            }

            return false;
        }

        if ( nodo && typeof nodo === 'object' ) {

            for ( const key of Object.keys( nodo ) ) {

                if ( buscarYSustituirAcuerdo( nodo[key], bloquesAcuerdo ) ) { return true; }
            }
        }

        return false;
    }

    const insertarAcuerdoEnPosicion = ( sfdt: string ) => {

        const contenidoAcuerdo = notificacion.contenidoAcuerdo;

        if ( !contenidoAcuerdo || !sfdt.includes('[Acuerdo_Notificar]') ) { return sfdt; }

        try {
            const documento = JSON.parse( sfdt );
            const acuerdoDocumento = JSON.parse( contenidoAcuerdo );
            const bloquesAcuerdo = acuerdoDocumento?.sec?.[0]?.b ?? [];

            const insertado = buscarYSustituirAcuerdo( documento, bloquesAcuerdo );

            return insertado ? JSON.stringify( documento ) : sfdt;
        }
        catch ( e ) {
            return sfdt.replaceAll('[Acuerdo_Notificar]', '');
        }

    }

    const construirDropdowns = useCallback(() => {

        const data = notificacionRef.current;
        const { expediente, amparo, exhortoRecibido, irregular } = data;

        const mkItem = ( text: string, id: string, value: string ): ItemModelModif[] =>
            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];

        const joinNames = ( arr: string[] ) => arr.join(', ');

        let items: ItemModelModif[] = [
            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
            ...mkItem('Tipo de Notificacion', '2', data.tipoNotificacion),
            ...mkItem('Contenido del Acuerdo', '50', data.contenidoAcuerdo),
            ...mkItem('Forma de Notificacion', '4', data.formaNotificacion),
            ...mkItem('Persona a Notificar', '5', data.personaNotificar),
            ...mkItem('Domicilio a Notificar', '6', data.domicilioNotificar),
            ...mkItem('Autoridad', '17', data.autoridad),
            ...mkItem('Ciudad', '18', data.ciudad),
        ];

        if ( data.idAmparo !== 0 ) {
            items.push(
                ...mkItem('Número de Expediente', '3', expediente.numeroExpediente),
                ...mkItem('Número de Amparo', '20', amparo.numeroAmparo),
                ...mkItem('Actor', '15', joinNames( expediente.actores )),
                ...mkItem('Demandado', '16', joinNames( expediente.demandados )),
                ...mkItem('Juez', '19', amparo.juez),
            );
        }
        else if ( data.idIrregular !== 0 ) {
            items.push(
                ...mkItem('Número de Irregular', '3', irregular.numeroIrregular),
                ...mkItem('Actor', '15', joinNames( irregular.actores )),
                ...mkItem('Demandado', '16', joinNames( irregular.demandados )),
                ...mkItem('Juez', '19', irregular.juez),
            );
        }
        else if ( data.idExpediente !== 0 ) {
            items.push(
                ...mkItem('Número de Expediente', '3', expediente.numeroExpediente),
                ...mkItem('Actor', '15', joinNames( expediente.actores )),
                ...mkItem('Demandado', '16', joinNames( expediente.demandados )),
                ...mkItem('Juez', '19', expediente.juez),
            );
        }
        else if ( data.idExhortoRecibido !== 0 ) {
            items.push(
                ...mkItem('Número de Exhorto', '3', exhortoRecibido.numeroExhorto),
                ...mkItem('Actor', '15', joinNames( exhortoRecibido.actores )),
                ...mkItem('Demandado', '16', joinNames( exhortoRecibido.demandados )),
                ...mkItem('Juez', '19', exhortoRecibido.juez),
            );
        }

        if ( items[items.length - 1]?.separator ) { items.pop(); }

        const acuerdos = data.acuerdos ?? [];

        const itemsAcuerdos: ItemModelModif[] = acuerdos.flatMap( ( acuerdo, index, registros ) => {
            const item: ItemModelModif = {
                id: acuerdo?.idAcuerdo.toString() ?? '',
                text: '(GAC-' + ( acuerdo?.idAcuerdo ?? ''  ) + ') - ' + ( acuerdo?.tipoAcuerdo ?? '' ) + ' - ' + ( acuerdo?.fecha ?? '' ),
                tipoAcuerdo: acuerdo?.tipoAcuerdo ?? '',
                fecha: acuerdo?.fecha ?? '',
                iconCss: 'e-icons e-bookmark',
                value: acuerdo?.contenido ?? '',
            };

            return ( index < ( registros.length - 1 ) ) ? [item, { separator: true }] : [item];
        });

        try { dropCampos.current?.destroy(); } catch { /* ya estaba destruido o desmontado */ }

        dropCampos.current = new DropDownButton({
            items: items,
            iconCss: 'e-icons e-drop-down',
            beforeItemRender: (item: ItemModelModif) => {
                return `<div>
                            <span class="e-menu-icon ${item.iconCss}"></span>
                            <span class="custom-class" >${item.text}</span>
                        </div>`;
            },
            select: (args) => {
                const value = args?.item?.value ?? "";
                const docEditor = syncfusionEditor.current?.documentEditor;

                if ( args?.item?.id === "50" ) {
                    try {
                        docEditor?.editor.paste( value );
                    } catch (e) {
                        console.error("No se pudo insertar el contenido del acuerdo, se insertará como texto plano:", e);
                        docEditor?.editor.insertText( (value ?? "").replace(/<[^>]*>/g, '') );
                    } finally {
                        setTimeout(() => construirDropdowns(), 200);
                    }
                } else {
                    docEditor?.editor.insertText(value);
                }
            }
        });

        dropCampos.current?.appendTo('#dropItem');

        try { dropCamposAcuerdos.current?.destroy(); } catch { /* ya estaba destruido o desmontado */ }
       
        dropCamposAcuerdos.current = null;

        if ( itemsAcuerdos.length !== 0 ) {

            dropCamposAcuerdos.current = new DropDownButton({
                items: itemsAcuerdos,
                iconCss: 'e-icons e-table-of-content',
                beforeItemRender: (args: { item: ItemModelModif; element: HTMLElement }) => {
                    const item = args.item;

                    if ( item.separator ) return;

                    args.element.innerHTML = `<div style="display:flex; align-items:center; gap:10px; width:100%;">
                                <span class="e-menu-icon ${item.iconCss}"></span>
                                <span style="font-size:14px; font-weight:600; flex-shrink:0;">GAC-${item.id}</span> 
                                
                                <span style="font-size:12px; color:#888; margin-left:auto; flex-shrink:0; padding-left:6px;">-</span>
                                <span style="font-size:12px; margin-left:auto; flex-shrink:0; padding-left:6px;">${item.tipoAcuerdo}</span>

                                <span style="font-size:12px; color:#888; margin-left:auto; flex-shrink:0; padding-left:6px;">-</span>
                                <span style="font-size:12px; margin-left:auto; flex-shrink:0; padding-left:6px;">${item.fecha}</span>
                            </div>`;
                },
                select: (args) => insertarContenidoAcuerdoRef.current( args?.item?.value ?? "" ),
            });

            dropCamposAcuerdos.current?.appendTo('#dropItemAcuerdos');
        }
    }, []);

    const montarDropdowns = useCallback(() => {

        setTimeout(() => construirDropdowns(), 200);

    }, [ construirDropdowns ]);

    const insertarContenidoAcuerdo = useCallback(( value: string ) => {
        const docEditor = syncfusionEditor.current?.documentEditor;

        try {
            if ( /<\/?[a-z][\s\S]*>/.test( value ) ) {
                docEditor?.editor.insertText( value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/&/g, "").replace(/acute;/g, "") ?? "" );
            }
            else {
                docEditor?.editor.paste( value );
            }
        }
        catch ( e ) {
            docEditor?.editor.insertText( (value ?? "").replace(/<[^>]*>/g, '') );
        }
        finally {
            montarDropdowns();
        }
    }, [ montarDropdowns ]);

    insertarContenidoAcuerdoRef.current = insertarContenidoAcuerdo;

    const handleEditorCreated = () => {

        setEditorReady( true );

    };

    useEffect(() => {

        async function obtener() {

            setLoading( true );

            await DetalleNotificacion( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setNotificacion( resp );

                        setTipoNotificacion( resp.idTipoNotificacion );
                        setFormaNotificacion(resp.idFormaNotificacion );
                        setPlantillaTemp(resp.idPlantilla );

                        const contenido = resp.contenido ?? '';

                        if ( !( /<\/?[a-z][\s\S]*>/.test(contenido) ) ) {

                            setContenido( contenido ?? defaultDocument );

                        }

                        notificacionRef.current = resp;
                        construirDropdowns();

                        if ( resp.contenido !== '' ) {
                            setActivarFinalizar(true);
                        }

                           if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading(false);
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading(false);
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ resp.usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 28 ) {
                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 28 ) {
                            setLoading( false );
                        }

                        setLoading(false);

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            obtener();
        }

    }, [ Id, construirDropdowns ])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoNotificacion().then( resp => {
                setTipoNotificacionArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerFormaNotificacion().then( resp => {
                setFormaNotificacionArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setPlantilla( 0 );
            setPlantillaArray( [] );

            const params = {
                idTipoAcuerdo: 0,
                idSubTipoAcuerdo: 0,
                idAutoridad: 0,
                idTipoNotificacion: tipoNotificacion,
            };

            await ObtenerPlantilla( params ).then(resp => {

                setPlantillaArray( resp );

            });

        }

        if ( tipoNotificacion !== 0 ) {
            Obtener();
        }

    }, [ tipoNotificacion ])

    useEffect(() => {

        if ( plantillaTemp !== 0 && plantillaArray.length !== 0 ) {
            setPlantilla( plantillaTemp );
        }

    }, [ plantillaTemp, plantillaArray ])

    useEffect(() => {

        if ( editorReady && syncfusionEditor.current ) {

            if ( contenido ) {
                syncfusionEditor.current?.documentEditor.open( contenido );
            }
            else {
                syncfusionEditor.current?.documentEditor.open( DefaultDocumentEditor() );
            }

        }

    }, [ loading, contenido, editorReady ])

    useEffect(() => {

        if ( editorReady && syncfusionEditor.current && !initialPage.current ) {

            if ( syncfusionEditor.current ) {
                syncfusionEditor.current.documentEditorSettings.showRuler = true;
                syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';
            }

            montarDropdowns();
            initialPage.current = true;
        }

    }, [ loading, editorReady, montarDropdowns ])

    useEffect(() => {

        if ( editorReady && onChangeTab ) {

            if ( contenido ) {
                syncfusionEditor.current?.documentEditor.open( contenido );
            }
            else {
                syncfusionEditor.current?.documentEditor.open( DefaultDocumentEditor() );
            }

            if ( syncfusionEditor.current ) {
                syncfusionEditor.current.documentEditorSettings.showRuler = true;
                syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';
            }

            montarDropdowns();

            setOnChangeTab(false);
        }

    }, [ onChangeTab, contenido, editorReady, montarDropdowns ])

    useEffect(() => {

        if ( editorReady && !cancelarNotificacion ) {

            if ( contenido ) {
                syncfusionEditor.current?.documentEditor.open( contenido );
            }
            else {
                syncfusionEditor.current?.documentEditor.open( DefaultDocumentEditor() );
            }

            if ( syncfusionEditor.current ) {
                syncfusionEditor.current.documentEditorSettings.showRuler = true;
                syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';
            }

            montarDropdowns();

            setOnChangeTab(false);
        }

    }, [ cancelarNotificacion, contenido, editorReady, montarDropdowns ])

    useEffect(() => {

        if ( editorReady && !cancelarBoleta ) {

            if ( contenido ) {
                syncfusionEditor.current?.documentEditor.open( contenido );
            }
            else {
                syncfusionEditor.current?.documentEditor.open( DefaultDocumentEditor() );
            }

            if ( syncfusionEditor.current ) {
                syncfusionEditor.current.documentEditorSettings.showRuler = true;
                syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';
            }

            montarDropdowns();

            setOnChangeTab(false);
        }

    }, [ cancelarBoleta, contenido, editorReady, montarDropdowns ])

    return (
        <Layout breadcrumbs={ [{ text: 'Notificación' }, { text: 'Generar notificación' }] } backgroundPaper={( procesoTerminado || procesoCancelado || procesoNoEncontrado )}>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ notificacion.idEstatus === 3 } />
                    :
                        <>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                <Tabs value={ value } onChange={ handleChange }>

                                    <Tab label="Notificación" {...TabProps(0)} />
                                    
                                    <Tab
                                        label="Información del amparo"
                                        sx={{ display: notificacion.idAmparo !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(1)}
                                    />

                                    <Tab
                                        label="Información del expediente"
                                        sx={{ display: notificacion.idExpediente !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(2)}
                                    />

                                    <Tab
                                        label="Información del exhorto"
                                        sx={{ display: notificacion.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(3)}
                                    />

                                    <Tab
                                        label="Información del irregular"
                                        sx={{ display: notificacion.idIrregular !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(4)}
                                    />

                                </Tabs>

                            </Box>

                            <TabPanel value={ value } index={ 0 }>

                                <Box p={ 4 } component={ Paper }>

                                    <BoxHeaderInformacion
                                        numeroSeguimiento={ `GNT-${notificacion.idNotificacion}` }
                                        fecha={ new Date() }
                                        numeroBoleta={ notificacion.numeroBoleta } 
                                    />

                                    <Grid container spacing={ 3 } mt={ 3 }>

                                        <Grid size={{ md: 4, xs: 12 }}>

                                            <List disablePadding>

                                                <ListItem sx={{ py: 0, px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Persona a notificar </Typography> }
                                                        secondary={
                                                            <Typography variant='subtitle2' fontWeight={ 'bold' }>
                                                                {
                                                                    notificacion.personaNotificar
                                                                }
                                                            </Typography>
                                                        }
                                                    />

                                                </ListItem>

                                            </List>

                                        </Grid>

                                        <Grid size={{ md: 5, xs: 12 }}>

                                            <List disablePadding>

                                                <ListItem
                                                    sx={{ py: 0, pl: 0, pr: 5 }}
                                                    secondaryAction={
                                                        <IconButton color="primary" onClick={ () => setOpenAgregarDomicilio( true ) }>
                                                            <EditIcon />
                                                        </IconButton>
                                                    }
                                                >

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Domicilio a notificar </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> {notificacion.domicilioNotificar} </Typography> }
                                                    />

                                                </ListItem>

                                            </List>

                                        </Grid>

                                        <Grid size={{ md: 3, xs: 12 }}>

                                            <Button
                                                fullWidth
                                                variant="contained"
                                                onClick={ () => { setOpenDocumento( true ); setDocumento( notificacion.acuerdo ); } }
                                                sx={{ mt: 1 }}
                                            >
                                                { notificacion.tipoOficio ? 'Ver Oficio a notificar' : 'Ver Acuerdo a notificar' }
                                            </Button>

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <FormControl fullWidth>
                                                <InputLabel>Tipo de notificación</InputLabel>

                                                <Select
                                                    label="Tipo de notificación"
                                                    value={ tipoNotificacion }
                                                    onChange={ (e) => { setTipoNotificacion(e.target.value); setFormaNotificacion(0); setPlantilla(0); } }

                                                >
                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                    {
                                                        tipoNotificacionArray
                                                        .filter( (e) => e.idTipoNotificacion === 1 || e.idTipoNotificacion === 2 || e.idTipoNotificacion === 5 )
                                                        .map( ( e ) => (
                                                            <MenuItem key={ e.idTipoNotificacion } value={ e.idTipoNotificacion }>{e.descripcion}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <FormControl fullWidth>
                                                <InputLabel>Forma de notificación</InputLabel>

                                                <Select
                                                    label="Forma de notificación"
                                                    value={ formaNotificacion }
                                                    onChange={ ( e ) => setFormaNotificacion( parseInt( e.target.value.toString() ) ) }
                                                >
                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                    {
                                                        tipoNotificacion === 1
                                                        ?
                                                        formaNotificacionArray
                                                        .filter( (e) => e.idFormaNotificacion === 1 )
                                                        .map( ( e ) => (
                                                            <MenuItem key={ e.idFormaNotificacion } value={ e.idFormaNotificacion }>{e.descripcion}</MenuItem>
                                                        ))
                                                        :
                                                        formaNotificacionArray
                                                        .map( ( e ) => (
                                                            <MenuItem key={ e.idFormaNotificacion } value={ e.idFormaNotificacion }>{e.descripcion}</MenuItem>
                                                        ))

                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        {
                                            notificacion.numeroBoleta === ""
                                            &&
                                            <>
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <FormControl>

                                                        <FormLabel>¿Desea cancelar la notificación?</FormLabel>
                                                        <RadioGroup row>

                                                            <FormControlLabel value="Si" control={ <Radio checked={ cancelarNotificacion === true } onChange={ () => { setCancelarNotificacion( true ); setPlantilla(0) } } /> } label="Si" />
                                                            <FormControlLabel value="No" control={ <Radio checked={ cancelarNotificacion === false } onChange={ () => { setCancelarNotificacion( false ); } } /> } label="No" />

                                                        </RadioGroup>

                                                    </FormControl>

                                                </Grid>
                                            </>
                                        }

                                        {
                                            notificacion?.numeroBoleta
                                            &&
                                            <>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <FormControl>

                                                        <FormLabel>¿Desea cancelar la boleta de notificación?</FormLabel>
                                                        <RadioGroup row>
                                                            <FormControlLabel value="Si" control={ <Radio checked={ cancelarBoleta === true } onChange={ () => { setCancelarBoleta( true ); setMotivoCancelacionBoleta(''); setPlantilla(0) } } /> } label="Si" />
                                                            <FormControlLabel value="No" control={ <Radio checked={ cancelarBoleta === false } onChange={ () => { setCancelarBoleta( false ); setMotivoCancelacionBoleta(''); } } /> } label="No" />

                                                        </RadioGroup>

                                                    </FormControl>

                                                </Grid>
                                                {
                                                    cancelarBoleta
                                                    &&
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <TextField
                                                            fullWidth
                                                            multiline
                                                            rows={ 4 }
                                                            label='Motivo de cancelación de la boleta'
                                                            autoComplete="off"
                                                            variant="outlined"
                                                            name="observaciones"
                                                            value={ motivoCancelacionBoleta }
                                                            onChange={ ( e ) => { setMotivoCancelacionBoleta( e.target.value ); } }
                                                            slotProps={{
                                                                input: {
                                                                    autoComplete: 'off'
                                                                },
                                                                inputLabel: {
                                                                    shrink: true,
                                                                }
                                                            }}

                                                        />

                                                    </Grid>
                                                }

                                            </>
                                        }

                                        {
                                            !cancelarBoleta && !cancelarNotificacion
                                            &&

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                    <FormControl fullWidth>
                                                        <InputLabel>Plantilla</InputLabel>

                                                        <Select
                                                            label="Plantilla"
                                                            name="plantilla"
                                                            value={ plantilla }
                                                            onChange={ (e) => { obtenerPlantilla(e.target.value); } }
                                                            disabled={
                                                                (tipoNotificacion === 0)
                                                            }
                                                        >
                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                plantillaArray
                                                                .map( ( e ) => (
                                                                    <MenuItem key={ e.idPlantilla } value={ e.idPlantilla }>{e.descripcion}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>

                                                </Grid>
                                            }

                                        {
                                            (!cancelarBoleta && !cancelarNotificacion)
                                            &&
                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <DocumentEditorContainerComponent
                                                    key='DocumentEditorContainer'
                                                    serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                    height='650'
                                                    ref={ syncfusionEditor }
                                                    enableToolbar={ true }
                                                    showPropertiesPane={ false }
                                                    toolbarItems={ Toolbar }
                                                    autoResizeOnVisibilityChange={ false }
                                                    created={ handleEditorCreated }
                                                >
                                                </DocumentEditorContainerComponent>

                                            </Grid>
                                        }

                                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                            <Grid container spacing={ 3 }>

                                                <Grid size={{ md: 6, xs: 12 }} sx={{ textAlign: 'right' }}>

                                                    <Button
                                                        fullWidth
                                                        color='secondary'
                                                        variant="outlined"
                                                        loading={ loadingGuardar }
                                                        onClick={ handleGuardar }
                                                    >
                                                        Guardar
                                                    </Button>

                                                </Grid>

                                                <Grid size={{ md: 6, xs: 12 }} style={{ textAlign: 'left' }}>
                                                    <Button
                                                        fullWidth
                                                        color='primary'
                                                        variant="contained"
                                                        onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        disabled={
                                                            ( 
                                                                !cancelarBoleta && !cancelarNotificacion && 
                                                                (
                                                                    !activarFinalizar ||
                                                                    notificacion.domicilioNotificar === ''
                                                                )
                                                            ) || 
                                                            ( cancelarBoleta && motivoCancelacionBoleta === '' )
                                                        }
                                                    >
                                                        Finalizar
                                                    </Button>
                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Box>

                            </TabPanel>

                            <TabPanel value={ value } index={ 1 }>

                                <BoxInformacionAmparo amparo={ notificacion.amparo } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 2 }>

                                <BoxInformacionExpediente expediente={ notificacion.expediente } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 3 }>

                                <BoxInformacionExhortoRecibido exhortoRecibido={ notificacion.exhortoRecibido } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 4 }>

                                <BoxInformacionIrregular irregular={ notificacion.irregular } />

                            </TabPanel>
                        </>
            }

            <Dialog
                fullWidth
                maxWidth='xs'
                open={ openDialogConfirmacionFinalizar }
                onClose={ () => { } }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText>
                        ¿Desea finalizar la generación de la cédula de notificación?
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                </DialogActions>
            </Dialog>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

            <DialogAgregarDomicilio
                openDialog={ openAgregarDomicilio }
                idPersona={ notificacion.idPersonaNotificar }
                idDomicilio={ notificacion.idDomicilioNotificar ?? 0 }
                SeleccionarDomicilio={ handleDomicilio }
                handleCloseDialog={ () => setOpenAgregarDomicilio( false ) }
            />

        </Layout>
    )
}
